import React, { useEffect, useState } from "react";

// components
import Button from "../../../../../../components/Button";
import Input from "../../../../../../components/Inputs/InputText";
import FormModal from "../../../../../../components/Modal/Templates/FormModal";
import Typography from "../../../../../../components/Text";

// utils
import { MAX_NAME_LENGTH } from "../../utils";

//store
import { useEditFormStore } from "../../useEditFormStore";

type SaveFormAsCopyModalProps = {
	isModalOpen: boolean;
	handleClose: () => void;
	handleSaveFormAsCopy: (name: string) => void;
};

const SaveFormAsCopyModal = ({ isModalOpen, handleClose, handleSaveFormAsCopy }: SaveFormAsCopyModalProps) => {
	const { name: formName } = useEditFormStore((state) => ({
		name: state?.name,
	}));

	const [formCopyName, setFormCopyName] = useState<string>(`${formName} (Copy)`);
	const [error, setError] = useState<string>("");

	useEffect(() => {
		if (!isModalOpen) {
			setFormCopyName(`${formName} (Copy)`);
		}
	}, [formName, isModalOpen]);

	return (
		<FormModal
			title={
				<Typography weight="semi-bold" size="sub-heading">
					Save Form As Copy
				</Typography>
			}
			buttons={[
				<Button key="cancel" onClick={handleClose}>
					Cancel
				</Button>,
				<Button key="save" color="green" submit>
					Save as Copy
				</Button>,
			]}
			isOpen={isModalOpen}
			handleClose={handleClose}
			onSubmit={(e) => {
				e.preventDefault();
				if (!formCopyName) {
					setError("Name cannot be empty.");
				} else if (formCopyName.length > MAX_NAME_LENGTH) {
					setError(`Name must be less than ${MAX_NAME_LENGTH} characters.`);
				} else {
					setError("");
					handleSaveFormAsCopy(formCopyName);
				}
			}}
		>
			<Input
				label="Form Name"
				value={formCopyName}
				onChange={(value) => setFormCopyName(value)}
				autoFocus
				errorMessage={error}
			/>
		</FormModal>
	);
};

export default SaveFormAsCopyModal;
